import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.12",
  "description": "Turborepo 1.12 adds popular community-requested features and feedback improvements.",
  "date": "2024/01/30",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.12 adds popular community-requested features and feedback improvements, including:"
  }, {
    "heading": "",
    "content": "Colors in task logs: Colors from original shell logs used by default"
  }, {
    "heading": "",
    "content": "Errors overhaul: Improved error messages for misconfigurations"
  }, {
    "heading": "",
    "content": "Improved inputs ergonomics: Use Turborepo's defaults with your input customizations"
  }, {
    "heading": "",
    "content": "Telemetry: Help us focus on what matters most to Turborepo users"
  }, {
    "heading": "",
    "content": "We're also done cleaning up our migration to Rust in this release by removing the --go-fallback flag and shrinking the turbo binary by 58% compared to 1.11."
  }, {
    "heading": "",
    "content": "Update today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "colors-in-task-logs",
    "content": "Color is a great way to quickly surface important information in user interfaces. It's common for developer tooling to highlight success in green, warnings in yellow, or errors in red."
  }, {
    "heading": "colors-in-task-logs",
    "content": "In this release, we're now showing the colors from your underlying tasks in your local environment by default. This has been a popular request from the community and we're excited to ship support for macOS and Linux today. We will be following up with Windows support in a future release."
  }, {
    "heading": "errors-overhaul",
    "content": "An important part of developer experience is ensuring that, when things go wrong, it's clear how to get back to the happy path. In this release, we've improved the error messages that come from Turborepo misconfigurations."
  }, {
    "heading": "errors-overhaul",
    "content": "In this enhanced UI, we are:"
  }, {
    "heading": "errors-overhaul",
    "content": "Showing you the errorful code"
  }, {
    "heading": "errors-overhaul",
    "content": "Improving the help text in your terminal for each type of error"
  }, {
    "heading": "errors-overhaul",
    "content": "Providing a link to documentation when it can provide you with useful context"
  }, {
    "heading": "improved-inputs-ergonomics",
    "content": "Turborepo intelligently understands the inputs to your tasks by default. But there are also situations where you may want to include or exclude specific files or directories from your task inputs."
  }, {
    "heading": "improved-inputs-ergonomics",
    "content": "Importantly, using the inputs key on a task opts you out of all of the default inputs for a task, like omitting gitignored files from your inputs. Until today, you had to manually bring back these defaults by creating glob patterns for them yourself."
  }, {
    "heading": "improved-inputs-ergonomics",
    "content": "Today, we're adding $TURBO_DEFAULT$ as a special value when used in the inputs array."
  }, {
    "heading": "improved-inputs-ergonomics",
    "content": "This microsyntax allows you to use the Turborepo defaults you're used to while adding in your own custom globs to fine tune the default input behavior."
  }, {
    "heading": "improved-inputs-ergonomics",
    "content": "Check out the inputs documentation for more information."
  }, {
    "heading": "telemetry",
    "content": "Turborepo was released almost two years ago, and turbo has developed considerably over the past two years. As the community has grown, the value of your feedback is immeasurable in helping us stay focused on what matters most to Turborepo users."
  }, {
    "heading": "telemetry",
    "content": "Until now, our feedback gathering process has been manual, slow, and error prone. While we will always highly appreciate users who file GitHub Issues, speak to us in GitHub Discussions, and chat with the community in Discord, this feedback only captures the sentiment of a small corner of the Turboverse."
  }, {
    "heading": "telemetry",
    "content": "Today, we're introducing a completely anonymous, automated approach to feedback to learn more about the ways that the community is using Turborepo. As we continue to iterate on turbo, this information will help us ensure performance, confirm stability, design new features, and drive the project's direction."
  }, {
    "heading": "telemetry",
    "content": "We're creating the build system of the future and this information will be highly valuable to guide us in that effort. For more information, visit turborepo.com/docs/telemetry."
  }, {
    "heading": "telemetry",
    "content": "If you'd like to opt out of telemetry, run:"
  }, {
    "heading": "telemetry",
    "content": "You may also opt-out by setting an environment variable:"
  }, {
    "heading": "telemetry",
    "content": "TURBO_TELEMETRY_DISABLED=1"
  }, {
    "heading": "telemetry",
    "content": "DO_NOT_TRACK=1 (per the Console Do Not Track (DNT) specification)"
  }, {
    "heading": "other-improvements",
    "content": "[Feature]: Enable pty usage (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Feature]: Support $TURBO_DEFAULT$ in inputs (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Feature]: Support Yarn 4 patches (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Feature]: Enable telemetry (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Treat empty environment variables as unset (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Error out if dependent flags are provided without their parent (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Make sure that our concurrency check ignore packages without tasks (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Avoid panic on invalid directory filters (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Ignore permission errors during globbing (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Avoid retry panic (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Rewrite prefix after carriage return (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Validate graph extension (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Truncate metadata file when writing (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Correctly create symlinks to directories (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Make sure cookie dir exists before writing cookie (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Examples turbo.json outputs key (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Filter package.json files that are subfolders of other packages (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Sort dependents and dependencies during normalization (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Swap fallback logs to debug (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Include gitignored files in fallback (PR)"
  }, {
    "heading": "other-improvements",
    "content": "[Improvement]: Include default files in fallback (PR)"
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo 1.11 we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "24.0k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "1.9M+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "238 years of compute time saved using Vercel Remote Cache"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "colors-in-task-logs",
    "content": "Colors in task logs"
  }, {
    "id": "errors-overhaul",
    "content": "Errors overhaul"
  }, {
    "id": "improved-inputs-ergonomics",
    "content": "Improved inputs ergonomics"
  }, {
    "id": "telemetry",
    "content": "Telemetry"
  }, {
    "id": "other-improvements",
    "content": "Other Improvements"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {ThemeAwareImage} from '#components/theme-aware-image';
export const toc = [{
  depth: 2,
  url: "#colors-in-task-logs",
  title: _jsx(_Fragment, {
    children: "Colors in task logs"
  })
}, {
  depth: 2,
  url: "#errors-overhaul",
  title: _jsx(_Fragment, {
    children: "Errors overhaul"
  })
}, {
  depth: 2,
  url: "#improved-inputs-ergonomics",
  title: _jsxs(_Fragment, {
    children: ["Improved ", _jsx("code", {
      children: "inputs"
    }), " ergonomics"]
  })
}, {
  depth: 2,
  url: "#telemetry",
  title: _jsx(_Fragment, {
    children: "Telemetry"
  })
}, {
  depth: 2,
  url: "#other-improvements",
  title: _jsx(_Fragment, {
    children: "Other Improvements"
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.12"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, January 30th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['mehulkar', 'tomknickman', 'gregsoltis']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.12 adds popular community-requested features and feedback improvements, including:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#colors-in-task-logs",
          children: _jsx(_components.strong, {
            children: "Colors in task logs"
          })
        }), ": Colors from original shell logs used by default"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#errors-overhaul",
          children: _jsx(_components.strong, {
            children: "Errors overhaul"
          })
        }), ": Improved error messages for misconfigurations"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-inputs-ergonomics",
          children: _jsxs(_components.strong, {
            children: ["Improved ", _jsx(_components.code, {
              children: "inputs"
            }), " ergonomics"]
          })
        }), ": Use Turborepo's defaults with your input customizations"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#telemetry",
          children: _jsx(_components.strong, {
            children: "Telemetry"
          })
        }), ": Help us focus on what matters most to Turborepo users"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["We're also done cleaning up our migration to Rust in this release by removing the ", _jsx(_components.code, {
        children: "--go-fallback"
      }), " flag and shrinking the ", _jsx(_components.code, {
        children: "turbo"
      }), " binary by 58% compared to 1.11."]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "colors-in-task-logs",
      children: "Colors in task logs"
    }), "\n", _jsx(_components.p, {
      children: "Color is a great way to quickly surface important information in user interfaces. It's common for developer tooling to highlight success in green, warnings in yellow, or errors in red."
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal running a `turbo` task with colors from the underlying shell logs.',
        src: '/images/blog/turbo-1-12-0/log-colors-light.png',
        props: {
          width: 625,
          height: 1000,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal running a `turbo` task with colors from the underlying shell logs.',
        src: '/images/blog/turbo-1-12-0/log-colors-dark.png',
        props: {
          width: 625,
          height: 1000,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "In this release, we're now showing the colors from your underlying tasks in your local environment by default. This has been a popular request from the community and we're excited to ship support for macOS and Linux today. We will be following up with Windows support in a future release."
    }), "\n", _jsx(_components.h2, {
      id: "errors-overhaul",
      children: "Errors overhaul"
    }), "\n", _jsx(_components.p, {
      children: "An important part of developer experience is ensuring that, when things go wrong, it's clear how to get back to the happy path. In this release, we've improved the error messages that come from Turborepo misconfigurations."
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal attempting to run a `turbo` task but receiving an informative error that an unknown key `output`, was found in the `turbo.json` file.',
        src: '/images/blog/turbo-1-12-0/light-errors-overhaul.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal attempting to run a `turbo` task but receiving an informative error that an unknown key `output`, was found in the `turbo.json` file.',
        src: '/images/blog/turbo-1-12-0/errors-overhaul-dark.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "In this enhanced UI, we are:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Showing you the errorful code"
      }), "\n", _jsx(_components.li, {
        children: "Improving the help text in your terminal for each type of error"
      }), "\n", _jsx(_components.li, {
        children: "Providing a link to documentation when it can provide you with useful context"
      }), "\n"]
    }), "\n", _jsxs(_components.h2, {
      id: "improved-inputs-ergonomics",
      children: ["Improved ", _jsx(_components.code, {
        children: "inputs"
      }), " ergonomics"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo intelligently understands the inputs to your tasks by default. But there are also situations where you may want to include or exclude specific files or directories from your task inputs."
    }), "\n", _jsxs(_components.p, {
      children: ["Importantly, using the ", _jsx(_components.code, {
        children: "inputs"
      }), " key on a task opts you out of all of the default inputs for a task, like omitting gitignored files from your inputs. Until today, you had to manually bring back these defaults by creating glob patterns for them yourself."]
    }), "\n", _jsxs(_components.p, {
      children: ["Today, we're adding ", _jsx(_components.code, {
        children: "$TURBO_DEFAULT$"
      }), " as a special value when used in the ", _jsx(_components.code, {
        children: "inputs"
      }), " array."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!README.md\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!**.test.**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "This microsyntax allows you to use the Turborepo defaults you're used to while adding in your own custom globs to fine tune the default input behavior."
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: ["Check out the ", _jsx(_components.code, {
          children: "inputs"
        }), " documentation"]
      }), " for more information."]
    }), "\n", _jsx(_components.h2, {
      id: "telemetry",
      children: "Telemetry"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo was released almost two years ago, and ", _jsx(_components.code, {
        children: "turbo"
      }), " has developed considerably over the past two years. As the community has grown, the value of your feedback is immeasurable in helping us stay focused on what matters most to Turborepo users."]
    }), "\n", _jsxs(_components.p, {
      children: ["Until now, our feedback gathering process has been manual, slow, and error prone. While we will always highly appreciate users who file ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/issues",
        children: "GitHub Issues"
      }), ", speak to us in ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/discussions",
        children: "GitHub Discussions"
      }), ", and chat with the community in ", _jsx(_components.a, {
        href: "https://turborepo.com/discord",
        children: "Discord"
      }), ", this feedback only captures the sentiment of a small corner of the Turboverse."]
    }), "\n", _jsxs(_components.p, {
      children: ["Today, we're introducing a ", _jsx(_components.strong, {
        children: "completely anonymous"
      }), ", automated approach to feedback to learn more about the ways that the community is using Turborepo. As we continue to iterate on ", _jsx(_components.code, {
        children: "turbo"
      }), ", this information will help us ensure performance, confirm stability, design new features, and drive the project's direction."]
    }), "\n", _jsxs(_components.p, {
      children: ["We're creating the build system of the future and this information will be highly valuable to guide us in that effort. For more information, visit ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/telemetry",
        children: "turborepo.com/docs/telemetry"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "If you'd like to opt out of telemetry, run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " disable"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "You may also opt-out by setting an environment variable:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "TURBO_TELEMETRY_DISABLED=1"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "DO_NOT_TRACK=1"
        }), " (per the ", _jsx(_components.a, {
          href: "https://consoledonottrack.com/",
          children: "Console Do Not Track (DNT)"
        }), " specification)"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "other-improvements",
      children: "Other Improvements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Feature]"
        }), ": Enable pty usage ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7128",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Feature]"
        }), ": Support ", _jsx(_components.code, {
          children: "$TURBO_DEFAULT$"
        }), " in inputs ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7113",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Feature]"
        }), ": Support Yarn 4 patches ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6974",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Feature]"
        }), ": Enable telemetry ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7122",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Treat empty environment variables as unset ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6929",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Error out if dependent flags are provided without their parent ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6780",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Make sure that our concurrency check ignore packages without tasks ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6790",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Avoid panic on invalid directory filters ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6955",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Ignore permission errors during globbing ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6957",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Avoid retry panic ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6926",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Rewrite prefix after carriage return ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6989",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Validate graph extension ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6995",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Truncate metadata file when writing ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7016",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Correctly create symlinks to directories ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/6983",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Make sure cookie dir exists before writing cookie ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7015",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Examples turbo.json outputs key ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7071",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Filter package.json files that are subfolders of other packages ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7025",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Sort dependents and dependencies during normalization ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7018",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Swap fallback logs to debug ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7102",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Include gitignored files in fallback ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7105",
          children: "(PR)"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[Improvement]"
        }), ": Include default files in fallback ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7106",
          children: "(PR)"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-1-11-0",
        children: "Turborepo 1.11"
      }), " we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "24.0k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "1.9M+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["238 years of compute time saved using ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of its contributors, including our core team."
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
